import { actionCreatorFactory } from 'typescript-fsa';
import { IGridDataHandlers } from '@cbridge-utils/datagrid';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IClientLp } from '@cbridge-packages/lp-client';
import { ISymbolLp, ISymbolLpKey, ILpSymbolName, IUnmappedSymbolsKey, ISymbolLpList, ISymbolLpIdentifier } from './symbolLp.interface';

export namespace SymbolLpAction {
  const actionCreator = actionCreatorFactory('SymbolLp');

  export const reload = actionCreator('RELOAD');
  export const load = actionCreator.async<ISymbolLpIdentifier, ISymbolLp, IApiErrorParams>('LOAD');
  export const loadList = actionCreator.async<ISymbolLpKey & IGridDataHandlers, ISymbolLpList, IApiErrorParams>('LOAD_LIST');
  export const loadUnmapped = actionCreator.async<IUnmappedSymbolsKey, ILpSymbolName[], IApiErrorParams>('LOAD_UNMAPPED');
  export const processing = actionCreator.async<void, void, void>('PROCESSING');

  interface ICreateSymbol {
    lpId: IClientLp['lpId'];
    data: ISymbolLp;
  }
  export const create = actionCreator.async<ICreateSymbol, void, IApiErrorParams>('CREATE');

  interface IUpdateSymbol {
    lpId: IClientLp['lpId'];
    data: Partial<ISymbolLp>;
  }
  export const update = actionCreator.async<IUpdateSymbol, void, IApiErrorParams>('UPDATE');

  interface IRemoveSymbol {
    lpId: IClientLp['lpId'];
    coreSymbolId: ISymbolLp['coreSymbolId'];
  }
  export const remove = actionCreator.async<IRemoveSymbol, void, IApiErrorParams>('REMOVE');

  export interface IBulkUpdateSymbols {
    lpId: IClientLp['lpId'];
    coreSymbolIds: ISymbolLp['coreSymbolId'][];
    priceMultiplier?: number;
    volumeMultiplier?: number;
    bidMarkup?: number;
    askMarkup?: number;
    minVolume?: number;
    maxVolume?: number;
    stepVolume?: number;
  }
  export const bulkUpdate = actionCreator.async<IBulkUpdateSymbols, void, IApiErrorParams>('BULK_UPDATE');

  export interface IBulkRemoveSymbols {
    lpId: IClientLp['lpId'];
    coreSymbolIds: ISymbolLp['coreSymbolId'][];
  }
  export const bulkRemove = actionCreator.async<IBulkRemoveSymbols, void, IApiErrorParams>('BULK_REMOVE');

  interface IExportFileParams {
    lpId: IClientLp['lpId'];
    showUnmapped?: boolean;
    sort?: string[];
    search?: string;
  }
  export const exportFile = actionCreator.async<IExportFileParams, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
